// extracted by mini-css-extract-plugin
export default {"base":"ErrorBlocked_base__WSLnF","icon":"ErrorBlocked_icon__KmvN6"};